import { render, staticRenderFns } from "./SettingsVersion.vue?vue&type=template&id=93a60bee"
import script from "./SettingsVersion.vue?vue&type=script&lang=js"
export * from "./SettingsVersion.vue?vue&type=script&lang=js"
import style0 from "./SettingsVersion.vue?vue&type=style&index=0&id=93a60bee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports